export default [
   
    // ' http://yofu.my/mahsing_v2'
    // ' http://yofu.my/vegetable_v2'
        // ' http://yofu.my/yofu_v2'
    //  ' http://mahsing-ent.com/mahsing'
      // ' http://mahsing-ent.com/art_veggies'
      // ' http://mahsing-ent.com/vege_testing'
      // ' https://petkeeper.com.my/vege_testing2'

    //  ' http://yofu.my/mahsing'

    //below for yofu
    ' https://yo.mdotservice.com/'
    //below for mahsing
      //  ' http://chafor.net/mahsing'
 //below for petkepe testing
      //  ' https://petkeeper.com.my/yofu'

      //  'https://yofu.lkmng.com/yofu'


    // ' http://chafor.net/mahsing_testing'
    // ' http://asiaweld.com.my/mahsing' 

    // 'http://vegeco.com.my/mahsingtest'

  ];
  
